/**
 * MCP 연결 상태 표시. 색은 상태에만 쓴다(연결됨=브랜드, 오류=위험, 나머지 중립)이고
 * 색만으로 구분하지 않도록 글자를 함께 둔다(ADV-L02). `dot`은 상태 바처럼 좁은 곳의 점 하나(툴팁에 글자).
 */
import { makeStyles, mergeClasses, tokens, Tooltip } from "@fluentui/react-components";
import { connectionText, type ConnectionStatus } from "./use-connection-status";

const useStyles = makeStyles({
  badge: { display: "inline-flex", alignItems: "center", gap: "6px", minWidth: 0, fontSize: tokens.fontSizeBase300, color: tokens.colorNeutralForeground2 },
  text: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
  dot: { width: "8px", height: "8px", borderRadius: tokens.borderRadiusCircular, flexShrink: 0, backgroundColor: tokens.colorNeutralForeground4 },
  connected: { backgroundColor: tokens.colorBrandBackground },
  error: { backgroundColor: tokens.colorStatusDangerBackground3 },
  listening: { backgroundColor: tokens.colorNeutralForeground3 },
});

export function ConnectionDot({ status }: { status: ConnectionStatus | null }) {
  const styles = useStyles();
  return <span aria-hidden className={mergeClasses(styles.dot, status?.state === "connected" && styles.connected, status?.state === "error" && styles.error, status?.state === "listening" && styles.listening)} />;
}

export function ConnectionBadge({ status }: { status: ConnectionStatus | null }) {
  const styles = useStyles();
  const text = connectionText(status);
  const detail = status?.state === "error" && status.detail ? `${text} · ${status.detail}` : text;
  return (
    <Tooltip content={`MCP: ${detail}`} relationship="description">
      <span className={styles.badge}>
        <ConnectionDot status={status} />
        <span className={styles.text}>{text}</span>
      </span>
    </Tooltip>
  );
}
